import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export interface VadStore {
  vadStatus: 'paused' | 'listening';
  setVadStatus: (status: 'paused' | 'listening') => void;
}

const initialState: VadStore = {
  vadStatus: 'paused',
  setVadStatus: () => { },
};

export const useVadStore = create<VadStore>()(
  subscribeWithSelector(
    devtools(
      immer((set) => ({
        ...initialState,
        setVadStatus: (status: 'paused' | 'listening') => {
          set((state) => {
            state.vadStatus = status;
          }, false, 'vad/set-vad-status');
        },
      }))
    )
  )
)